module.exports = __webpack_public_path__ + "img/manage_area.0a3f0e15.svg";